import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { signUp_action } from '../../actions/user_login_auth_actions/user_login_auth_action';
import { withRouter } from '../../utils/withRouter';
import Loader from '../../utils/Loader'
import { clearSessionStorage, toastError } from '../../utils/constants'
// import Header from '../../common_components/Header';
import { emailValidator, nameValidator, passwordValidator } from '../../utils/Validator'
import { booking_Details_action } from '../../actions/bookingDetails_action/bookingDetails_action';
import Modal from "react-modal";
import jQuery from 'jquery';
import $ from 'jquery'
// import Footerlogin from '../../common_components/Footerlogin';
// import AdminHeader from '../../common_components/admin_module_header';

/* 
 * mapDispatchToProps
*/
// const mapDispatchToProps = dispatch => ({
//     loginAction: () => dispatch(loginAction())
// })

/* 
 * mapStateToProps
*/


// const mapStateToProps = state => {
//   return {
//     loginData: state,
//   };
// }


class SignUp extends Component {
    constructor(props) {
        super(props)
        this.state = {
            userEmail: '',
            password: '',
            username: '',
            is_showpass: false,
            isOpen: false,
            isLoading: false,
            companyInfo: false,

            CenterID: ''
        }
        // this.handleObscure = this.handleObscure.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.navigateLogIn = this.navigateLogIn.bind(this)
    }

    jQuerycode = () => {
        // SLIDESHOW
        $(function () {
            $('#slideshow > div:gt(0)').hide();
            setInterval(function () {
                $('#slideshow > div:first')
                    .fadeOut(1000)
                    .next()
                    .fadeIn(1000)
                    .end()
                    .appendTo('#slideshow');
            }, 3850);
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        const { userEmail, username, password, companyInfo } = this.state
        // this.props.navigate("/dashboard");
        // console.log("testing-------------->", userEmail, password, username)
        var errMsg = nameValidator(username)
        var errMsg2 = emailValidator(userEmail)
        var errMsg3 = passwordValidator(password)
        if (errMsg != '' || errMsg2 != '' || errMsg3 != '') {
            toast.error(errMsg != '' ? errMsg : errMsg2 != '' ? errMsg2 : errMsg3 != '' ? errMsg3 : '', {
                theme: 'colored',
                autoClose: 1000,
                hideProgressBar: true,
            })
        } else {
            // console.log("sign")
            if (username != '' && userEmail != '' && password != '') {
                this.setState({ isLoading: true })
                this.props
                    .signUp_action(username, null, userEmail, password)
                    .then((data) => {
                        console.log(data, 'dataaaaaaaaaaaaaaaaaaa')
                        if (data && data.error != 1) {
                            // console.log("data.data", data)
                            if (password.includes('CSR')) {
                                this.props.navigate("/changePassword", { state: { is_forgotPassword: true } });
                            }
                            else if (companyInfo == true) {
                                this.props.navigate("/companyInfo", { state: { Is_CenterID: true } })
                            }
                            else {
                                this.props.navigate("/");
                            }

                            this.setState({ isLoading: false })
                        }
                        else {
                            this.setState({ isLoading: false })
                            toast.error(data.msg, {
                                theme: 'colored',
                                autoClose: 3000,
                                hideProgressBar: true,
                            })
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            }
            else {
                this.setState({ isLoading: false })

                toast.error('Please check user name and password', {
                    theme: 'colored',
                    autoClose: 1000,
                    hideProgressBar: true,
                })
            }
        }
    }

    componentDidMount() {
        this.jQuerycode()

        this.setState({
            companyInfo: this.props.location.state != null && this.props.location.state.companyInfo != null ? this.props.location.state.companyInfo : false,
            CenterID: this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : '',
        })

        // setTimeout(() => {
        //     console.log("bookingList@########$", this.state.bookingList)
        // }, 200);

    }

    handleKeyDown(e) {
        if (e.code === 'Enter') {
            this.handleSubmit(e)
        }
    }


    navigateLogIn() {
        const CenterID = this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : ''

        const companyInfo = this.props.location.state != null && this.props.location.state.companyInfo != null ? this.props.location.state.companyInfo : false

        this.props.navigate('/login', { state: { CenterID: CenterID, companyInfo: companyInfo } })
    }


    render() {
        const { userEmail, password, isLoading, isOpen, username, email, is_showpass, is_forgotPassword } = this.state
        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                {/* <AdminHeader isSteper={false}/> */}
                <>
                    <main>
                        <div class="login">
                            <div class="wrap">
                                <marquee
                                    style={{ fontSize: "16px", color: "#000", fontWeight: "500" }}
                                    behavior="scroll"
                                    direction="left"
                                    scrollamount="5"
                                    onMouseOver={(e) => e.target.stop()}
                                    onMouseOut={(e) => e.target.start()}
                                >
                                    <b>Disclaimer and Ownership: </b> All content, including text, graphics, images, and other materials on this website and associated online application systems/accounts, is the exclusive property of India ITME Society or is used under appropriate license. Unauthorized copying, reproduction, distribution, publication, display, modification, creation of derivative works, transmission, or any other form of exploitation of this content is strictly prohibited without prior written consent from the copyright owner. Any violation of these terms will result in immediate legal action and enforcement of intellectual property rights.
                                </marquee>
                                {/* <!-- SLIDER --> */}
                                <div class="content">
                                    <div class="logo">
                                        <a><img src="img/main-logo-green.png" alt="" style={{ width: "220px" }} /></a>
                                    </div>
                                    <img src="/img/down__2__page-0001-removebg-preview.png" class="log-bottom-img" />

                                </div>
                                {/* <!-- LOGIN FORM --> */}
                                <div class="user">
                                    {/* <!-- ACTIONS
                                <div class="actions">
                                  <a class="help" href="#signup-tab-content">Sign Up</a><a class="faq" href="#login-tab-content">Login</a>
                                </div>
                    --> */}
                                    <div class="form-wrap">
                                        {/* <!-- TABS --> */}
                                        <div class="tabs">
                                            <h3 class="login-tab"><a style={{ textDecoration: 'none' }} class="log-in" onClick={this.navigateLogIn}><span>Login</span></a></h3>
                                            <h3 class="signup-tab"><a style={{ textDecoration: 'none' }} class="sign-up active" ><span>Sign Up</span></a></h3>
                                        </div>
                                        {/* <!-- TABS CONTENT --> */}
                                        <div class="tabs-content">
                                            {/* <!-- TABS CONTENT LOGIN --> */}
                                            {/* <!-- TABS CONTENT SIGNUP --> */}
                                            <div>
                                                <div class="signup-form form">
                                                    <input type="text" class="input" placeholder="name" value={username}
                                                        onChange={(e) => this.setState({
                                                            username: e.target.value.split(' ')
                                                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                                .join(' ')
                                                        })}
                                                        onKeyDown={(e) => this.handleKeyDown(e)}
                                                        maxLength={70}
                                                    />
                                                    <input type="email" class="input" placeholder="Email" value={userEmail}
                                                        onChange={(e) => this.setState({ userEmail: e.target.value })}
                                                        onKeyDown={(e) => this.handleKeyDown(e)}
                                                        maxLength={50}
                                                    />
                                                    <div style={{ overflow: "hidden" }}>
                                                        <input type={is_showpass ? "text" : "password"} class="input" placeholder="Password" value={password}
                                                            onChange={(e) => this.setState({ password: e.target.value })}
                                                            onKeyDown={(e) => this.handleKeyDown(e)}
                                                            maxLength={25}
                                                        />
                                                        <i style={{
                                                            color: "black",
                                                            position: "relative",
                                                            fontSize: "20px",
                                                            top: "-44px",
                                                            left: "290px",
                                                            cursor: "pointer"
                                                        }}
                                                            className={`fa ${is_showpass ? "fa-eye-slash" : "fa-eye"} show-password`} // Use "fa-eye-slash" when is_showpass is true
                                                            onClick={() => this.setState((prevState) => ({ is_showpass: !prevState.is_showpass }))} // Toggle is_showpass state
                                                        ></i></div>
                                                    <a class="btn btn-primary login_btn" onClick={(e) => this.handleSubmit(e)}>Sign Up</a>

                                                    {/* <!-- <input type="submit" class="button" value="Sign Up"> --> */}
                                                </div>
                                                <div class="help-action">
                                                    <p>By signing up, you agree to our</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </main>
                </>
                {/* <Footerlogin /> */}

            </>
        );

    }


}

export default withRouter(connect(null, { signUp_action, booking_Details_action })(SignUp));
